//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
import * as apis from "@/api";
import UnpackgameInstanceItem from "../UnpackgameInstanceItem/index.vue";
export default {
  name: "awardAverageExtraCaseItem",
  props: {
    value: {
      type: Boolean,
      defalut: false,
    },
    average_case_info: {
      type: Object,
      default: () => ({}),
    },
  },
  model: {
    prop: "value",
    event: "on-sync",
  },
  data() {
    return {
      showAverage: false,
      case_details: {},
      unpackgameInstance_item_show: false,
    };
  },
  components: {
    "c-unpackgameInstance-item": UnpackgameInstanceItem,
  },
  watch: {
    value: {
      async handler(v) {
        if (v) {
          await this.getGameInstance();
        }
        this.showAverage = v;
      },
      deep: true,
      immediate: true,
    },
    showAverage(v) {
      this.$emit("on-sync", v);
    },
  },
  methods: {
    ...mapMutations(["setSpinShow"]),
    async getGameInstance() {
      // 获取当前副本箱子信息
      const case_info_response = await apis.api_CaseDetail(
        this.average_case_info.extraCaseId
      );
      this.setSpinShow(false);
      if (case_info_response.data.code !== 0) {
        return;
      }
      const respone = case_info_response.data.data;
      this.case_details = respone.caseInfo;
    },
    onGameInstanceBox() {
      this.showAverage = false;
      this.unpackgameInstance_item_show = true;
    },
    onUnpackgameInstanceClose(data) {
      //概率宝箱
      let obj = {
        awardAverageExtraCaseIndex:
          this.average_case_info.awardAverageExtraCaseIndex,
        data: data,
      };
      this.$emit("on-ongameInstanceRewardCloseHandle", obj);
    },
  },
};
